import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
import '../../assets/css/reset.css'
import MHome from './views/MHome'
import PHome from './views/PHome'
import { query as _query, ua as _ua } from '@yuanfudao/ccgp-common-util'
import frog from '@/plugins/frog'
import { Img2WebpPlugin } from '@yuanfudao/conan-webp-sdk'
import '../../utils/sentry'

Vue.use(Img2WebpPlugin)
Vue.use(frog)

Vue.use(VueLazyload, {
  preLoad: 1,
  loading: require('../../assets/images/img-loading.jpg'),
  error: require('../../assets/images/img-loading.jpg'),
  attempt: 1,
  dispatchEvent: true,
  filter: {
    webp(listener, options) {
      if (!options.supportWebp) return
      const isCDN = /fbcontent.cn/
      if (isCDN.test(listener.src)) {
        listener.src += '?x-oss-process=image/format,webp'
      }
    }
  }
})

const query = _query.parse()

let option = {
  template: '<PHome />',
  components: { PHome }
}
let devicetype = 'pc'

if (_ua.isMobile()) {
  option = {
    template: '<MHome />',
    components: { MHome }
  }
  devicetype = 'mobile'
}

const vue = new Vue({
  el: '#app',
  data: { query },
  ...option
})

vue.$addFrog('/event/ZebraAIWebsite/enter', [
  { key: 'pageType', value: 'goods' },
  { key: 'devicetype', value: devicetype }
])
